export function llmChatBasePath(): string {
  return '/llm-chat'
}

export function llmChatSessionPath(sessionId: string): string {
  return `/llm-chat/${sessionId}`
}

export function llmChatNewProductChatPath(productId: string): string {
  const params = new URLSearchParams({
    new: '1',
    mode: 'product',
    productId,
  })
  return `/llm-chat?${params.toString()}`
}

export function llmChatNewChatPath(): string {
  return '/llm-chat?new=1'
}
